/* eslint-disable no-console */
import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[icon]',
  standalone: true
})
export class IconButtonDirective implements OnInit {
  @Input() public icon = '';
  @Input() public size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'sm';
  @Input() public variant?: 'muted' | 'outlined' | 'ghost' = 'ghost';
  @Input() public color?: string = undefined;
  @Input() public active: boolean | undefined = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  public ngOnInit(): void {
    if (this.color !== undefined) {
      this.renderer.setStyle(this.el.nativeElement, 'color', this.color);
    }

    // Add variant class
    if (this.variant !== undefined) {
      this.renderer.addClass(this.el.nativeElement, this.variant);
    }

    // Add icon button base class
    this.renderer.addClass(this.el.nativeElement, 'icon-btn');

    this.renderer.addClass(this.el.nativeElement, this.size);

    // Add active class
    if (this.active === true) {
      this.renderer.addClass(this.el.nativeElement, 'active');
    }

    // Create and add the icon element
    if (this.icon) {
      const iconElement: HTMLElement = this.renderer.createElement('i');

      iconElement.classList.add('fa', ...this.icon.split(' '));
      iconElement.setAttribute('aria-hidden', 'true');

      // Clear button content
      this.el.nativeElement.innerHTML = '';

      // Add icon to button
      this.renderer.appendChild(this.el.nativeElement, iconElement);
    }

    // Blur on mouse up
    this.renderer.listen(this.el.nativeElement, 'mouseup', () => {
      this.el.nativeElement.blur();
    });
  }
}
